import { Menu as MenuWrapper } from '@mui/material';
import { useRef } from 'react';

import { useOnClickOutside } from '@shared/hooks/useOnClickOutside';
import { StyledMenuItem } from '@styles/Admin-tools/Workflows/WorkflowStepStyles';

type TMenuProps = {
  handleEditStepClick: () => void;
  handleAddSubStepClick: () => void;
  handleDeleteStepClick: () => void;
  handleEditParentStepClick: () => void;
  onClose: () => void;
  subprimeAnchorEl: HTMLElement;
};

const Menu = ({
  handleEditStepClick,
  handleAddSubStepClick,
  handleDeleteStepClick,
  handleEditParentStepClick,
  onClose,
  subprimeAnchorEl,
}: TMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onClose);

  return (
    <MenuWrapper
      ref={ref}
      id="basic-menu"
      anchorEl={subprimeAnchorEl}
      open={!!subprimeAnchorEl}
      MenuListProps={{ 'aria-labelledby': 'basic-button' }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={onClose}
    >
      <StyledMenuItem onClick={handleAddSubStepClick}>Add sub step</StyledMenuItem>
      <StyledMenuItem onClick={handleEditParentStepClick}>Edit parent step</StyledMenuItem>
      <StyledMenuItem onClick={handleEditStepClick}>Edit</StyledMenuItem>
      <StyledMenuItem onClick={handleDeleteStepClick}>Remove</StyledMenuItem>
    </MenuWrapper>
  );
};

export default Menu;
